import React, { useState, useEffect } from 'react';
import { TextField, Button, Box, MenuItem } from '@mui/material';

const RantingForm = ({ initialData, mwcUnits, onSave, onCancel }) => {
  const [name, setName] = useState('');
  const [address, setAddress] = useState('');
  const [mwcId, setMwcId] = useState('');

  useEffect(() => {
    if (initialData) {
      setName(initialData.name);
      setAddress(initialData.address || '');
      setMwcId(initialData.mwcId || '');
    } else {
      setName('');
      setAddress('');
      setMwcId('');
    }
  }, [initialData]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!name || !mwcId) return;
    onSave({ name, address, mwcId: parseInt(mwcId) });
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
      <TextField
        select
        label="Induk MWC"
        value={mwcId}
        onChange={(e) => setMwcId(e.target.value)}
        fullWidth
        margin="normal"
        required
      >
        <MenuItem value="" disabled>Pilih MWC</MenuItem>
        {mwcUnits.map((mwc) => (
          <MenuItem key={mwc.id} value={mwc.id}>
            {mwc.name}
          </MenuItem>
        ))}
      </TextField>
      <TextField
        label="Nama Ranting"
        fullWidth
        margin="normal"
        value={name}
        onChange={(e) => setName(e.target.value)}
        required
        autoFocus
      />
      <TextField
        label="Alamat (Opsional)"
        fullWidth
        margin="normal"
        value={address}
        onChange={(e) => setAddress(e.target.value)}
        multiline
        rows={2}
      />
      <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end', gap: 2, flexWrap: 'wrap' }}>
        <Button type="button" variant="outlined" onClick={onCancel}>
          Batal
        </Button>
        <Button type="submit" variant="contained" color="primary">
          {initialData ? 'Update' : 'Simpan'}
        </Button>
      </Box>
    </Box>
  );
};

export default RantingForm;
